import { defineMessages } from 'react-intl-next';

export default defineMessages({
    feedbackPreambleTitleText: {
        defaultMessage: '<p>Your thoughts are valuable in helping improve our products.</p>{br}',
        description: 'Feedback Preamble Title',
        id: 'sd.feedback.collector.feedback.preamble.title.text',
    },
    canContactLabelText: {
        defaultMessage: 'Atlassian can contact me about this feedback. See our <a>privacy policy</a>',
        description: 'Can Contact Label Text',
        id: 'sd.feedback.collector.can.contact.label.text',
    },
    enrolLabelText: {
        defaultMessage: "I'd like to help improve Atlassian products by joining the <a>Atlassian Research Group</a>",
        description: 'Enrol Label',
        id: 'sd.feedback.collector.enrol.label.text',
    },
    feedbackTitle: {
        defaultMessage: 'Share your thoughts',
        description: 'Feedback Title',
        id: 'sd.feedback.collector.feedback.title',
    },
    summaryPlaceholder: {
        defaultMessage: "Let us know what's on your mind",
        description: 'Summary Placeholder',
        id: 'sd.feedback.collector.summary.placeholder',
    },
    questionSelectOptionLabel: {
        defaultMessage: 'Ask a question',
        description: 'Select option label for Question',
        id: 'sd.feedback.collector.question.select.option.label',
    },
    questionFieldLabel: {
        defaultMessage: 'What would you like to know?',
        description: 'Label to be shown when user chooses question from drop down',
        id: 'sd.feedback.collector.question.field.label',
    },
    commentSelectOptionLabel: {
        defaultMessage: 'Leave a comment',
        description: 'Select option label for Comment',
        id: 'sd.feedback.collector.comment.select.option.label',
    },
    commentFieldLabel: {
        defaultMessage: "Let us know what's on your mind",
        description: 'Label to be shown when user chooses comment from drop down',
        id: 'sd.feedback.collector.comment.field.label',
    },
    bugSelectOptionLabel: {
        defaultMessage: 'Report a bug',
        description: 'Select option label for Bug',
        id: 'sd.feedback.collector.bug.select.option.label',
    },
    bugFieldLabel: {
        defaultMessage: 'Describe the bug or issue',
        description: 'Label to be shown when user chooses bug from drop down',
        id: 'sd.feedback.collector.bug.field.label',
    },
    suggestionSelectOptionLabel: {
        defaultMessage: 'Suggest an improvement',
        description: 'Select option label for Suggestion',
        id: 'sd.feedback.collector.suggestion.select.option.label',
    },
    suggestionFieldLabel: {
        defaultMessage: "Let us know what you'd like to improve",
        description: 'Label to be shown when user chooses Suggestion from drop down',
        id: 'sd.feedback.collector.suggestion.field.label',
    },
    emptySelectOptionLabel: {
        defaultMessage: 'I want to...',
        description: 'Select option label for Empty',
        id: 'sd.feedback.collector.empty.select.option.label',
    },
    emptyFieldLabel: {
        defaultMessage: 'Select an option',
        description: 'Label to be shown when user chooses Empty from drop down',
        id: 'sd.feedback.collector.empty.field.label',
    },
    submitButtonLabel: {
        defaultMessage: 'Send feedback',
        description: 'Submit Button Label',
        id: 'sd.feedback.collector.submit.button.label',
    },
    cancelButtonLabel: {
        defaultMessage: 'Cancel',
        description: 'Cancel Button Label',
        id: 'sd.feedback.collector.cancel.button.label',
    },
    feedbackSentFlagTitle: {
        defaultMessage: 'Thanks',
        description: 'Feedback Sent Flag Title',
        id: 'sd.feedback.collector.feedback.sent.flag.title',
    },
    feedbackSentFlagDescription: {
        defaultMessage: 'Your valuable feedback helps us continually improve our products.',
        description: 'Feedback Title',
        id: 'sd.feedback.collector.feedback.sent.flag.description',
    },
});
